import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { clearQueries } from '../lib/Queries';
import * as Api from '../lib/Api';

const LogoutPage = ({}) => {
    const { logout } = useAuth0();
    useEffect(() => {
        clearQueries();

        Api.post('/api/logout');

        // We need to wait for query client to persist the clearing to the cache
        //  https://github.com/TanStack/query/discussions/3280
        //  it defaults to a 1000ms timeout
        setTimeout(() => {
            logout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            }).then(() => {
                // Logged out!
                console.log('Successfully logged out');
            });
        }, 1100);
    });

    return <div>Logging out...</div>;
};

export default LogoutPage;
